module.exports = __webpack_public_path__ + "img/Code71.812e67dc.svg";